<template>
    <div class="row">
        <div class="col-12">
            <h3>Enviar un acceso al organizador para ver el detalle de ventas</h3>
        </div>
        <div class="col-12" v-if="!evento.userViewer">
            <Button @click="createUser">Crear acceso</Button>                     
        </div>
        <template v-else>
            <div class="col-12">
                <p><b>(Le llegará un email con el usuario y contraseña para ver las ventas actualizadas y descargar el informe)</b></p>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <input type="email" placeholder="Email" id="email" name="email" v-model="email">
                </div>                                    
            </div>
            <div class="col-12 text-justify">
                <Button @click="enviar(evento.userViewer.id)">Enviar acceso</Button>
                <Button class="float-right" @click="borrarAcceso(evento.userViewer.id)">Borrar acceso</Button>
            </div>
        </template>                            
    </div>
</template>

<script>

export default {
    props: ['evento'],
    data() {
        return {
            email: ''
        }
    },
    methods: {
        createUser() {
            const data = {
                evento_id: this.evento.id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.user_viewer.create'), data).then(res => {
                this.$emit('actualizar');
            }).catch(err => {
                this.$toast.error(err.response.data.message);
            });
        },
        borrarAcceso(event_viewer_user_id) {
            const data = {
                evento_id: this.evento.id,
                event_viewer_user_id: event_viewer_user_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.user_viewer.delete'), data).then(res => {
                this.$emit('actualizar');
            });
                
        },
        enviar(event_viewer_user_id) {
            const data = {
                evento_id: this.evento.id,
                event_viewer_user_id: event_viewer_user_id,
                email: this.email
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.user_viewer.enviar'), data).then(res => {
                this.$toast.success(res.data.message);
            });
        }
    }
}
</script>